module.exports = __webpack_public_path__ + "media/application/images/svgs/demsoc/header_images/header-a-d3f1ffc10c0eeb824988b30a8125afba.svg";